import type { SceneObject } from '../types/scene'
import { registry } from '../components-lib/registry'

/**
 * 用于区分同名对象的「基底」名称：用户自定义名优先，否则用组件注册名或 type。
 */
export function baseDisplayName(obj: SceneObject): string {
  const def = registry.get(obj.type)
  const raw = (obj.name?.trim() || def?.name || obj.type || '').trim()
  return raw || obj.type
}

/**
 * 当多个对象基底名相同时，在列表/气泡等处显示「基底名 1」「基底名 2」；
 * 仅一个对象时只显示基底名，不追加编号。
 */
export function buildObjectDisplayNameMap(objects: SceneObject[]): Map<string, string> {
  const bases = objects.map((o) => ({ id: o.id, base: baseDisplayName(o) }))
  const countByBase = new Map<string, number>()
  for (const { base } of bases) {
    countByBase.set(base, (countByBase.get(base) ?? 0) + 1)
  }
  const indexByBase = new Map<string, number>()
  const result = new Map<string, string>()
  for (const { id, base } of bases) {
    const total = countByBase.get(base) ?? 1
    if (total <= 1) {
      result.set(id, base)
    } else {
      const next = (indexByBase.get(base) ?? 0) + 1
      indexByBase.set(base, next)
      result.set(id, `${base} ${next}`)
    }
  }
  return result
}
